function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1401 0H10.0801V3.18002H14.0801V22.06H17.2501V3.18002H24.1201L24.1401 0Z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0.0117188H5.85999V3.18173H0V0.0117188Z",
  fill: "#33cccc"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M42.4997 0.0117188H28.4297V3.18173H32.4297V22.0717H35.5997V3.18173H42.4997V0.0117188Z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M69.0003 21.7891V23.4591H52.3203V21.7891H69.0003Z",
  fill: "#ffff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.8096 10.5898H42.9796V13.7299H39.8096V10.5898Z",
  fill: "#33cccc"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2496 13.7578H45.8496V22.0978H49.2496V13.7578Z",
  fill: "#ffff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M61.2596 6.94861C61.2596 7.04861 61.2596 7.1486 61.2596 7.2486C61.2596 7.3486 61.2596 7.6886 61.1996 7.9086C61.1396 8.1286 61.1997 8.07861 61.1497 8.16861V8.41861C60.8985 9.56046 60.3597 10.6192 59.5844 11.4943C58.809 12.3693 57.8229 13.0318 56.7196 13.4186L56.4696 13.4986L56.0197 13.6186H55.8397L55.4996 13.7286H55.2496H55.1696C54.9596 13.7286 54.7397 13.7286 54.5197 13.7286H49.2896V10.5586H52.9296H54.5197C55.4771 10.5586 56.3953 10.1783 57.0723 9.50125C57.7493 8.82424 58.1296 7.90604 58.1296 6.94861C58.1296 5.99118 57.7493 5.07297 57.0723 4.39597C56.3953 3.71896 55.4771 3.33859 54.5197 3.33859H52.9296H49.2896V10.5986H45.8896V0.0585938H54.8896C56.3547 0.16068 57.7482 0.730936 58.8645 1.68521C59.9808 2.63949 60.7609 3.92727 61.0897 5.35861L61.1497 5.60861C61.1497 5.70861 61.1496 5.8086 61.1996 5.9086V6.2186C61.2396 6.4686 61.2596 6.72861 61.2596 6.94861Z",
  fill: "#ffff"
});

function SvgLogoTtp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 24,
    viewBox: "0 0 69 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTtp);
export default __webpack_public_path__ + "static/media/logo-ttp.8e93a9e2.svg";
export { ForwardRef as ReactComponent };